export default "__VITE_ASSET__DX7zGgWm__"